import React, { useEffect } from "react";
import AOS from "aos";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Homepage from "./pages/Homepage";
import UseLenis from "./components/useLenis";
import { ParallaxProvider } from "react-scroll-parallax";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import { initGA } from "./components/Analytics";
import EducationPage from "./pages/EducationPage";
import AboutPage from "./pages/About";
// import ChatPage from "./pages/ChatPage";
// import ChanakyaAi from "./pages/ChanakyaAi";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import RefundPolicy from "./pages/RefundPolicy";
import CareersPage from "../src/pages/Careers";
import NotFoundPage from "./components/NotFound";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
    });
  }, []);
  useEffect(() => {
    initGA();
  });
  return (
    <ParallaxProvider>
      <BrowserRouter>
        <UseLenis>
          <Routes>
            <Route path="/" element={<EducationPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/refundpolicy" element={<RefundPolicy />} />
            <Route path="/tos" element={<TermsOfService />} />
            <Route path="/careers" element={<CareersPage />} />
            {/* <Route path="/edu-business" element={<EducationPage />} /> */}
            <Route path="/about-us" element={<AboutPage />} />
            {/* <Route path="/how-it-works" element={<ChanakyaAi />} /> */}
            {/* <Route path="/chat" element={<ChatPage />} /> */}
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </UseLenis>
      </BrowserRouter>
    </ParallaxProvider>
  );
};

export default App;
